import type { SearchDocument, SearchResponse } from '@cfa/pathway-fe-shared/xp';

import {
  consolidateSearchDocuments,
  getResourceIdsWithDuplicateSearchRows,
} from '@/utils/consolidateSearchDocuments';

export type ExploreSearchPage = SearchResponse & {
  /** Page-1 API rows before client dedupe (Explore choose-version detection). */
  clientRawPageResults?: SearchDocument[];
};

/** Single-page explore search: deduped results + metadata for choose-version. */
export type ExploreSearchViewModel = ExploreSearchPage & {
  rawFirstPageResults: SearchDocument[];
  duplicateSearchResourceIds: string[];
};

/** Map GET /search page-1 response to deduped UI + choose-version metadata. */
export const buildExploreSearchViewModel = (
  response: SearchResponse | undefined,
): ExploreSearchViewModel | undefined => {
  if (!response) {
    return undefined;
  }

  const rawResults = response.results ?? [];
  const visibleResults = consolidateSearchDocuments(rawResults);
  const duplicateSearchResourceIds =
    getResourceIdsWithDuplicateSearchRows(rawResults);

  return {
    ...response,
    results: visibleResults,
    clientRawPageResults: rawResults,
    rawFirstPageResults: rawResults,
    duplicateSearchResourceIds,
  };
};
